export const DEFAULT_STORAGE_PROVIDER = 's3';

export type StorageProviderId = 'r2' | 's3';

export function parseStorageProviderId(
  value: string | null | undefined
): StorageProviderId | null {
  const normalized = value?.trim().toLowerCase();
  if (normalized === 'r2' || normalized === 's3') {
    return normalized;
  }

  return null;
}
